import { USER_ROLES } from "../constant/roles";

export const GLOBAL_ADMIN_ROLES = [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN];

export const isGlobalAdminRole = (role) => GLOBAL_ADMIN_ROLES.includes(role);

export default isGlobalAdminRole;
